<template>

  <div>
    <ContentsHeader>
      <template v-slot:title01>{{jobName}}</template>
      <template v-slot:explain01>
        商品の売り手と買い手の仲介役となり輸出入をするBtoB企業で働く営業職が商社営業です。 総合商社では幅広い商品取扱の仲介に加え、事業投資をメインにおこなう場合もあります。一方、特定の分野に強みをもつのが専門商社です。 取り扱う商品の種類が膨大な商社営業に求められるのは、幅広い知識や情報収集力をもとにした提案力です。海外への事業拡大を進める企業では、語学力や国際取引の知識に加え、グローバルでの専門性ある知見が求められます。なんでも売れるだけになんでも求められそうなこの業界の営業職にはどんな特徴が見られるのでしょうか。
      </template>
      <template v-slot:yarigai01><span class="ddin">個人では相手にされにくい大企業との取引</span><span class="ddin">(愛知県 51歳 男性)</span></template>
      <template v-slot:yarigai02><span class="ddin">自分が提案、提供した商材によって顧客に利益が出たとき</span><span class="ddin">(山形県 50歳 男性)</span></template>
      <template v-slot:yarigai03><span class="ddin">大きい裁量が与えられ責任をもった仕事ができること</span><span class="ddin">(東京都 27歳 女性)</span></template>
      <template v-slot:img-headbg><img src="../assets/img/shosha/headbg.svg" :alt="jobName" class="img -shosha"></template>
      <template v-slot:img-headp><img src="../assets/img/shosha/person.svg" :alt="jobName" class="imgp -shosha"></template>
    </ContentsHeader>

    <div class="contents-block">

      <section class="job-section">
        <div class="jsinner">
          <div class="block-two -aistretch -jcsb -bptablet">
            <div class="block -b48p -p0">
              <BalanceChartSection :explain="bcExplain" :radarData="radarData"></BalanceChartSection>
            </div>
            <div class="block -b48p -p0">
              <JobChangeRateSection
                :explain="jcExplain"
                :doughnutData="doughnutData"
                :doughnutDataFake="doughnutData"
              ></JobChangeRateSection>
            </div><!-- .block -->
          </div><!-- .block-two -->
        </div><!-- .jsinner -->
      </section>

      <PersonalCharaSection :sevenData="sevenData" :secTtl="'商社'" >
        <template v-slot:feature>外向的で<br>大胆なパートナー</template>
        <template v-slot:imgpup><img src="../assets/img/shosha/person.svg" alt="商社の営業の営業" class="imgcvperson -shosha"></template>
      </PersonalCharaSection>
    
      <div class="lb-area">
        <div class="lbinner block-two -bptablet">
          <div class="block">
            <CareerTypeSection :graphData="graphData" :explain="ctExplain" :jobName="'商社'"></CareerTypeSection>
          </div><!-- .block -->
          <div class=" block">
            <SalesTypeSection :graph2Data="graph2Data" :explain="stExplain" :jobName="'商社'"></SalesTypeSection>
          </div><!-- .block -->
        </div><!-- .block-two -->
      </div><!-- .lb-area -->

      <ResultSection :job="'shosha'">
        <template v-slot:jobname>商社の営業</template>
        <template v-slot:title01>外向的で大胆な社交家</template>
        <template v-slot:explain01>
積極的に人とかかわったり、周りから刺激を受けることを好む好奇心旺盛な傾向が強いことが読み取れます。各所にパイプを作ったり、情報収集を行ったりすることに長けているといえるでしょう。世界各地の膨大な商品を取り扱う商社営業には、不可欠な能力です。        </template>
        <template v-slot:title02>商社営業は経営者？</template>
        <template v-slot:explain02>
他業界と比べ、起業家的な感性を持つ人が多い傾向にあります。商社営業の業務は「川上から川下まで」と表現されるように、原材料の輸入から製品の物流まで一貫して事業に携わるため、経営者的な視点が必要であるということが分かります。        </template>
        <template v-slot:imgperson><img src="../assets/img/shosha/person.svg" alt="商社の営業の営業" class="rsimg"></template>
      </ResultSection>

      <section class="other-section">
        <h2 class="osttl">その他の業界ごとの詳細をのぞく</h2>
        <div class="osinner">
          <DetailsList :job="'shosha'"></DetailsList>
        </div><!-- .osinner -->
      </section>

    </div><!-- contents-block -->
  </div>

</template>

<script>

import ContentsHeader from "../components/ContentsHeader.vue";
import ResultSection from "../components/ResultSection.vue";
import DetailsList from "../components/DetailsList.vue";

import BalanceChartSection from "../components/BalanceChartSection.vue";
import JobChangeRateSection from "../components/JobChangeRateSection.vue";
import PersonalCharaSection from "../components/PersonalCharaSection.vue";
import CareerTypeSection from "../components/CareerTypeSection.vue";
import SalesTypeSection from "../components/SalesTypeSection.vue";

export default {
  data() {
    return {
      pageTitle: "商社の営業をのぞく",
      pageURL: "shosha",
      pageDescription: "SALES SALES SCOPEでは不動産、保険、ITなど人気10業界の営業職に人物特性と成績に関する調査を実施。商品の売り手と買い手の仲介役となり輸出入をするBtoB企業で働く営業職が商社営業です。なんでも売れるだけになんでも求められそうなこの業界の営業職にはどんな特徴が見られるのでしょうか。",

      jobName: "商社の営業",
      bcExplain: "社交性に長けており計画性はやや低め",
      jcExplain: "転職回数は平均的",
      pcExplain: "外向的で大胆なパートナー",
      ctExplain:
        "新しい価値創造を目指す起業家タイプと<br>困難な課題の解決をのぞむチャレンジャータイプが多い",
      stExplain:
        "戦略的思考に沿って行動するタイプが多く、顧客と親密になろうとするタイプは少ない",
      radarData: [6.68, 8.1, 5.41, 4.88, 6.66],
      doughnutData: [38, 25, 21, 8, 8],
      doughnutData2: [38, 62],
      sevenData: [6, 4, 4, 5, 4, 3, 3],
      graphData: [
        { num: 1, val: 4 },
        { num: 2, val: 17 },
        { num: 3, val: 4 },
        { num: 4, val: 8 },
        { num: 5, val: 21 },
        { num: 6, val: 8 },
        { num: 7, val: 25 },
        { num: 8, val: 13 },
      ],
      graph2Data: [
        { num: 1, val: 12.5 },
        { num: 2, val: 20.8333333333333 },
        { num: 3, val: 29.1666666666667 },
        { num: 4, val: 12.5 },
        { num: 5, val: 25 },
      ],
    };
  },
  components: {
    BalanceChartSection,
    JobChangeRateSection,
    PersonalCharaSection,
    CareerTypeSection,
    SalesTypeSection,
    ContentsHeader,
    ResultSection,
    DetailsList    
  },
  metaInfo: {
    title: "商社の営業をのぞく | 営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },
  },
  mounted: function(){
    // document.title = title;
    document.querySelector("meta[name='description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:title']").setAttribute('content', this.pageTitle + " | 営業職の特徴を人物特性からのぞいてみた | SALES SCOPE");
    document.querySelector("meta[property='og:description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:url']").setAttribute('content', 'https://sales-score.jp/scope/' + this.pageURL);
  }
};
</script>